module.exports = __webpack_public_path__ + "img/Span-08.b10cac3e.jpg";